import { useMutation } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const editBannerForm = async (payload: CarouselBanner) => {
	const url = `/homepage/admin/fullscreentakeover/${payload.id}/`;
	const response = await cmsClient.put<CarouselBanner>(url, payload);

	return response.data;
};

const useEditFullScreenTakeover = () => {
	const mutation = useMutation(editBannerForm);

	return mutation;
};

export default useEditFullScreenTakeover;
